export const upcomingPaymentsInitialState = {
  data: [],
  page: 0,
  maxRows: 0,
  rows: 0,
  hasMore: false,
  filtersHavedChanged: false,
  filters: [],
  columnsOrder: {},
  columns: [],
  totals: [],
};
